import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { DateField, type DateRangePickerToolbarProps } from '@mui/x-date-pickers-pro';
import SDatePicker from 'components/SDatePicker';
import React from 'react';
import { isMobile } from 'react-device-detect';
import useStyles from './styles';
import type { DateTime } from 'luxon';

interface CustomToolbarProps extends DateRangePickerToolbarProps<DateTime> {
  startDate: DateTime | null;
  endDate: DateTime | null;
  handleInputChange: (field: 'start' | 'end', value: DateTime | null) => void;
  handleInputFocus: () => void;
  handleInputClear: (field: 'start' | 'end') => void;
  keyboardButtonClassName: string;
  errors?: {
    startHelperText?: string;
    endHelperText?: string;
  };
}

function CustomToolbar({
  startDate,
  endDate,
  rangePosition,
  handleInputChange,
  handleInputFocus,
  handleInputClear,
  keyboardButtonClassName,
  errors,
}: CustomToolbarProps) {
  const { classes } = useStyles();

  return (
    <>
      {isMobile && (
        <div className={classes.datesContainer}>
          <DateField
            size='small'
            id='start'
            value={startDate}
            format='LLL d, yyyy'
            label='Start date'
            // disableOpenPicker
            onChange={(value) => handleInputChange('start', value)}
            onFocus={handleInputFocus}
            onClick={handleInputFocus}
            helperText={errors?.startHelperText}
            focused={rangePosition === 'start'}
            slotProps={{
              textField: {
                error: !!errors?.startHelperText,
              },
            }}
          />
          <DateField
            size='small'
            id='end'
            value={endDate}
            format='LLL d, yyyy'
            label='End date'
            // disableOpenPicker
            onChange={(value) => handleInputChange('end', value)}
            onFocus={handleInputFocus}
            onClick={handleInputFocus}
            helperText={errors?.endHelperText}
            focused={rangePosition === 'end'}
            slotProps={{
              textField: {
                error: !!errors?.endHelperText,
              },
            }}
          />
        </div>
      )}

      {!isMobile && (
        <div className={classes.datesContainer}>
          <SDatePicker
            // @ts-expect-error FIXME TS2322
            size='small'
            id='start'
            value={startDate}
            format='LLL d, yyyy'
            onChange={(value: DateTime) => handleInputChange('start', value)}
            label={'Start date'}
            textFieldProps={{
              onFocus: handleInputFocus,
              focused: rangePosition === 'start',
              InputProps: {
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      id={'clear-start-date'}
                      aria-label='clear start date'
                      onClick={() => handleInputClear('start')}
                      classes={{
                        root: keyboardButtonClassName,
                      }}
                    >
                      <ClearIcon fontSize={'inherit'} />
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
            disableOpenPicker
            error={!!errors?.startHelperText}
            helperText={errors?.startHelperText}
          />
          <SDatePicker
            // @ts-expect-error FIXME TS2322
            size='small'
            id='end'
            value={endDate}
            inputFormat='LLL d, yyyy'
            onChange={(value: DateTime) => handleInputChange('end', value)}
            label={'End date'}
            textFieldProps={{
              onFocus: handleInputFocus,
              focused: rangePosition === 'end',
              InputProps: {
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      id={'clear-end-date'}
                      aria-label='clear end date'
                      onClick={() => handleInputClear('end')}
                      classes={{
                        root: keyboardButtonClassName,
                      }}
                    >
                      <ClearIcon fontSize={'inherit'} />
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
            disableOpenPicker
            error={!!errors?.endHelperText}
            helperText={errors?.endHelperText}
          />
        </div>
      )}
    </>
  );
}

export default CustomToolbar;
